module.exports = __webpack_public_path__ + "img/img84.24b64b2c.png";